/** @format */

import { ScheduleItemProps } from './interface'
import dayjs from 'dayjs'

// 状态值枚举
export const StatusEnum = {
  active: '正常',
  not_configured: '未配置',
  not_started: '未开始',
  expired: '已过期'
}

/** 今天 00:00:00 */
export const todayStart = dayjs().startOf('day').format('YYYY-MM-DD HH:mm')

export const initScheduleValues: ScheduleItemProps = {
  Name: '',
  Description: '',
  DutyShift: [[]],
  Period: 'day',
  ChangeTime: '00:00',
  StartTime: todayStart,
  EndTime: ''
}

export const previewColorList = [
  '#7952B3',
  '#E83E8C',
  '#FFC107',
  '#FD7E14',
  '#20C997',
  '#0D6EFD',
  '#00B5E8'
]
// 预览表头日期
export const WEEKDAYS = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
